<template>
  <div class="loading-mask" v-if="visible">
    <div class="lds-roller">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      visible: false
    }
  }
}
</script>
<style lang="less" scoped>
  .loading-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    pointer-events: all;
  }
  .lds-roller {
    position: absolute;
    top: 30%;
    left: 50%;
    transform: translateX(-50%);
  }
</style>
